import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import './styles/theme.css';
import './styles/navbar.css';
import ErrorBoundary from './components/ErrorBoundary';
import Register from './components/Register';
import Login from './components/Login';
import SiteLayout from './components/SiteLayout';
import PrivateRoute from './components/PrivateRoute';
import VerifiedRoute from './components/VerifiedRoute';
import Landing from './pages/Landing';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Payment from './pages/Payment';
import Ask from './pages/Ask';
import Research from './pages/Research';
import Community from './pages/Community';
import Marketplace from './pages/Marketplace';
import VerifyEmail from './pages/VerifyEmail';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import AdminRoute from './components/AdminRoute';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <AnimatePresence mode="wait">
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Landing />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />

                <Route
                  element={
                    <PrivateRoute>
                      <Outlet />
                    </PrivateRoute>
                  }
                >
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/payment" element={<Payment />} />
                  <Route
                    path="/admin"
                    element={
                      <AdminRoute>
                        <Admin />
                      </AdminRoute>
                    }
                  />
                </Route>

                <Route
                  element={
                    <PrivateRoute>
                      <VerifiedRoute>
                        <Outlet />
                      </VerifiedRoute>
                    </PrivateRoute>
                  }
                >
                  <Route path="/home" element={<Home />} />
                  <Route path="/ask" element={<Ask />} />
                  <Route path="/ask/:conversationId" element={<Ask />} />
                  <Route path="/research" element={<Research />} />
                  <Route path="/community" element={<Community />} />
                  <Route path="/marketplace" element={<Navigate to="/marketplace/browse" replace />} />
                  <Route path="/marketplace/listings/:listingId" element={<Marketplace />} />
                  <Route path="/marketplace/:section" element={<Marketplace />} />
                </Route>
              </Route>

              <Route path="/verify-email" element={<VerifyEmail />} />
            </Routes>
          </AnimatePresence>
        </div>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
